/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  're-indent': {
    width: 12,
    height: 11,
    viewBox: '0 0 12 11',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd"><path pid="0" d="M10.334 4.201A4.543 4.543 0 0 0 5.978.95 4.517 4.517 0 0 0 1.644 4.2"/><path pid="1" d="M10.884 2.503l-.481 1.655-1.598-.465M1.657 6.733a4.543 4.543 0 0 0 4.356 3.252 4.517 4.517 0 0 0 4.335-3.252"/><path pid="2" d="M1.092 8.414l.51-1.647 1.59.493"/></g>'
  }
})
